export default __webpack_public_path__ + "media/zurb/img/events/soapbox/tinachen-697aab61d601aac74673ccc0f71e4c06.png";